const CircularArrowsIcon = ({ ...others }) => {
  return (
    <svg {...others} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.5 2.5C9.5 2 8.5 1.8 7.5 2C5 2.5 3.3 4.8 3.5 7.5L2 6'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d='M5.5 13.5C6.5 14 7.5 14.2 8.5 14C11 13.5 12.7 11.2 12.5 8.5L14 10'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CircularArrowsIcon;
